import { createSelector, createFeatureSelector } from '@ngrx/store';

import { AppState } from '../shared/models';

export const selectApp = createFeatureSelector<AppState>('app');

export const selectShipToExternalId = createSelector(
  selectApp,
  (store: AppState) => store.entityExternalId,
);
export const selectSystem = createSelector(selectApp, (store: AppState) => store.system);
export const isInitialized = createSelector(
  selectApp,
  (store: AppState) => store.initialized || false,
);
export const selectApplications = createSelector(
  selectApp,
  (store: AppState) => (store && store.applications) || [],
);
export const selectApplicationGroups = createSelector(
  selectApp,
  (store: AppState) => store.applicationGroups || [],
);
export const selectDatastreams = createSelector(
  selectApp,
  (store: AppState) => store.datastreams || [],
);
export const selectSingleApplicationDatastreams = createSelector(
  selectApp,
  (store: AppState) => store.applicationDatastreams || [],
);
export const selectApplicationDatastreams = createSelector(
  selectSingleApplicationDatastreams,
  selectApplications,
  (applicationDatastreams, applications) =>
    applications.map((application) => ({
      ...application,
      dataStreamKeys: applicationDatastreams
        .filter((applicationDatastream) => applicationDatastream.applicationKey === application.key)
        .reduce((acc, applicationDatastream) => [...acc, applicationDatastream.dataStreamKey], []),
    })),
);
export const selectApplicationGroupsWithApplicationDatastreams = createSelector(
  selectApplicationGroups,
  selectApplicationDatastreams,
  (applicationGroups, applicationDatastreams) =>
    applicationGroups.map((applicationGroup) => ({
      ...applicationGroup,
      applications: applicationDatastreams.filter(
        (applicationDatastream) => applicationDatastream.applicationGroupId === applicationGroup.id,
      ),
    })),
);
export const selectSelectedApplicationGroups = createSelector(
  selectApplicationGroupsWithApplicationDatastreams,
  (applicationGroups) =>
    applicationGroups.filter(
      (applicationGroup) =>
        applicationGroup.show ||
        applicationGroup.applications.reduce((acc, curr) => [...acc, ...curr.dataStreamKeys], [])
          .length > 0,
    ),
);

export const selectUnselectedApplicationGroups = createSelector(
  selectSelectedApplicationGroups,
  selectApplicationGroups,
  (selectedApplicationGroups, applicationGroups) =>
    applicationGroups.filter(
      (applicationGroup) =>
        !selectedApplicationGroups.find(
          (selectedApplicationGroup) => selectedApplicationGroup.id === applicationGroup.id,
        ),
    ),
);

export const hasUnselectedApplicationGroups = createSelector(
  selectUnselectedApplicationGroups,
  (applicationGroups) => applicationGroups && applicationGroups.length > 0,
);
